module.exports = __webpack_public_path__ + "assets/img/shop_tit.5f8c644b.png";